module.exports = __webpack_public_path__ + "assets/img/a6a5b1d83ccff2fabbdcd2d4050bddc5.svg";